import { GOOGLE, LINKEDIN, META, TIKTOK } from "../../../i18n/keysTranslations";

const PLATFORM_LABEL_KEYS = {
  meta: META,
  google: GOOGLE,
  tiktok: TIKTOK,
  linkedin: LINKEDIN,
};

/** Platform keys come as stored ("linkedIn"), so match them case-insensitively. */
const translateGlobalReportPlatform = (platform, t) => {
  const key = PLATFORM_LABEL_KEYS[String(platform).toLowerCase()];
  return key ? t(key) : platform;
};

export default translateGlobalReportPlatform;
